import { render, staticRenderFns } from "./LoanScheduleInvoiceVatListItem.vue?vue&type=template&id=24f6b4e7&scoped=true&lang=pug&"
import script from "./LoanScheduleInvoiceVatListItem.vue?vue&type=script&lang=js&"
export * from "./LoanScheduleInvoiceVatListItem.vue?vue&type=script&lang=js&"
import style0 from "./LoanScheduleInvoiceVatListItem.vue?vue&type=style&index=0&id=24f6b4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6b4e7",
  null
  
)

export default component.exports